import http from "../http-common";
/* eslint-disable */
class WebsiteService {
  websiteInfo(hostname) {
    return http.get(`/website/info?hostname=${hostname}`, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new WebsiteService();
